// extracted by mini-css-extract-plugin
export default {"container":"mBCkZ","infoIcon":"H94Aa"};